/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $BillingAccountCreate = {
    properties: {
        relAccount: {
            type: 'number',
            isNullable: true,
            format: 'int32',
        },
        accountNumber: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
        districtId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        disallowACHPayments: {
            type: 'boolean',
        },
        disallowCCPayments: {
            type: 'boolean',
        },
        status: {
            type: 'BillingAccountStatusEnum',
        },
        serviceStatus: {
            type: 'ServiceStatusEnum',
            isRequired: true,
        },
        customer: {
            type: 'CustomerCreate',
            isRequired: true,
        },
        amountDue: {
            type: 'number',
            isNullable: true,
            format: 'double',
        },
        dueDate: {
            type: 'string',
            isNullable: true,
            format: 'date-time',
        },
        pastDueAmount: {
            type: 'number',
            isNullable: true,
            format: 'double',
        },
        maxDraftAmount: {
            type: 'number',
            isNullable: true,
            format: 'double',
        },
        pauseAutoPay: {
            type: 'boolean',
            isNullable: true,
        },
    },
};